import { render, staticRenderFns } from "./cardWork.vue?vue&type=template&id=f5ad055a&scoped=true&"
import script from "./cardWork.vue?vue&type=script&lang=js&"
export * from "./cardWork.vue?vue&type=script&lang=js&"
import style0 from "./cardWork.vue?vue&type=style&index=0&id=f5ad055a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ad055a",
  null
  
)

export default component.exports